
(function () {
	'use strict';

	/**
	* @memberof app
	* @ngdoc controller
	* @name Ficha
	* @description
	* This is main controller
	**/

	angular
		.module('app')
		.controller('Ficha', Ficha);

	Ficha.$inject = ['ColaboracionService', '$scope', '$filter', '$location', '$anchorScroll', '$timeout', '$sce'];


	function Ficha(ColaboracionService, $scope, $filter, $location, $anchorScroll, $timeout, $sce) {
		console.log("ficha");
		var vm = this;
		vm.pagina = 0;
		vm.ficheros = [];
		vm.respuestas = [];
		vm.showfichastareas = false;
		vm.botonChecked = [];
		vm.archivosubido = false;
		vm.checkvalido = false;
		vm.questionClicked = false;
		vm.respuesta = [];
		vm.errorArchivo = false;
		vm.respuestasUsuario = [];
		vm.categoria_colaboracion;
		vm.progreso_colaboracion = [];
		vm.dateRange = false;
		vm.today = new Date();
		vm.fecha_final = false;
		$scope.videosVistos = {};
		vm.completada = false;
		vm.completadas = 0;
		vm.pendientes = 0;
		vm.ultima_respuesta = 0;
		vm.user_id = null;
		vm.startDate = null;
		vm.EndDate = null;
		vm.colaboracionesCompletadas = [];
		vm.colaboracionesPendientes = [];

		vm.hoy = $filter('date')(vm.today, "yyyy/MM/dd");
		vm.mymetype = null;
		vm.hash = false;
		
		vm.Categoriacolaboracion = function () {
			ColaboracionService.getCategoriacolaboracion()
				.then(function (data) {
					vm.categoria_colaboracion = data.categoria_colaboracion;

				})
		}

		vm.getNumericValue = function (val) {
			if (!val) return 0;
			var numeric = val.toString().replace(/[^0-9,]/g, '').replace(',', '.');
			return parseFloat(numeric) || 0;
		};

		vm.toDate = function (str) {
			if (!str || str === "" || str === "undefined") return null;
			if (str instanceof Date) return str;
			var d = moment(str, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", "DD/MM/YYYY", "D/M/YYYY"]);
			return d.isValid() ? d.toDate() : null;
		};

		vm.ordenarCompletadas = function (col) {
			var fText = (col && col.fecha_completada) ? col.fecha_completada : null;
			var d = vm.toDate(fText);
			if (!d) return 1; // Al final del todo
			return -d.getTime(); // Orden descendente
		};

		vm.Colaboraciones = function () {
			vm.colaboracionesPendientes = [];
			vm.colaboracionesCompletadas = [];
			ColaboracionService.getColaboraciones(vm.user_id).then(function (data) {
				vm.colaboraciones = data.colaboraciones;
				angular.forEach(vm.colaboraciones, function (col) {
					if (!col || !col.estado) {
						return;
					}
					var estadoId = col.estado.id;
					var fechaFinal = col.fecha_final ? moment(col.fecha_final, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY/MM/DD') : null;
					var fechaCaducada = fechaFinal && fechaFinal < vm.hoy;
					console.log(fechaCaducada,fechaFinal,vm.hoy);
					// PENDIENTES / DESCARTADAS (solo si no ha caducado por fecha)
					if ((estadoId == 132 || estadoId == 133) && !fechaCaducada) {
						vm.colaboracionesPendientes.push(col);
						return;
					}
					// COMPLETADAS / EN REVISIÓN / CADUCADAS (por estado o por fecha vencida)
					if (estadoId == 131 || estadoId == estado_colaboracion.en_revision || estadoId == estado_colaboracion.caducada
						|| ((estadoId == 132 || estadoId == 133) && fechaCaducada)) {
						vm.colaboracionesCompletadas.push(col);
						return;
					}
				});
				vm.completadas = data.completadas;
				vm.pendientes = data.pendientes;
				vm.limites = data.limites;
			});
		}

		vm.getRespuestasByUser = function () {
			ColaboracionService.getRespuestasByUser(vm.user_id).then(function (resp) {
				if (resp.status == 200) {
					vm.respuestasUsuario = resp.respuestas;
					vm.progreso_colaboracion = resp.progreso;
				}

			});
		}

		vm.getProceso = function (colaboracion_id) {
			var b = 0;

			angular.forEach(vm.progreso_colaboracion, function (value, key) {
				if (key == colaboracion_id)
					b = value;

			});
			return b;

		}

		vm.setRespValue = function (key, val) {
			if (vm.empty(vm.respuesta[key]))
				vm.respuesta[key] = val
		}

		vm.empty = function (val) {
			var empty = true;
			if (typeof val === "undefined" || typeof val === "null" || val == undefined || val == null)
				return empty;

			if (typeof val === 'string') {
				if (val.trim() === '')
					return empty;
			}

			if (typeof val === 'number') {
				if (!val)
					return empty;
			}

			if (typeof val === 'object') {

				if (val.length === undefined) {
					var r = false;
					angular.forEach(val, function (value, key) {
						if (typeof value === 'string') {
							if (value.trim() === '')
								r = true;

							if (value.trim() === '0')
								r = true;
						}
						if (typeof value === 'number') {
							if (value === 0)
								r = true;
						}
						if (value === undefined || value === undefined) {

							r = true;
						}
					});

					if (!Object.keys(val).length)
						r = true;



					if (r)
						return empty;
				} else {
					if (val.length) {
						if (!val[0])
							return !val[0];
						if (val[0].length !== undefined)
							return !val[0].length;
					}
				}

				if (val.length === 0)
					return empty;
			}
			return false;

		}

		vm.seleccionarTarea = function (key) {

			if (!key && key != 0) {
				return;
			}

			if (key < vm.pagina) {
				vm.pagina = key;
				swiperheader.slideTo(vm.pagina);
				return;
			}

			vm.pagina = key;
			swiperheader.slideTo(vm.pagina);
		}

		vm.Tareas = function () {
			ColaboracionService.getRespuestas(vm.id, vm.hash).then(function (resp) {
				ColaboracionService.getTareas(vm).then(function (data) {
					vm.tareas = data.tareas;

					vm.colaboraciones = data.colaboraciones;
					if (data.mymetype !== null) {
						vm.mymetype = data.mymetype;
						//vm.extensions = data.mymetype.extension.replaceAll(",", ', ');
					}

					if (vm.tareas && vm.tareas.length > 0) {
						vm.divisionTareas = (100 / vm.tareas.length).toFixed(2);
						vm.divisionTareas = parseFloat(vm.divisionTareas);
					}

					angular.forEach(vm.tareas, function (value, key) {
						//vm.respuestas[key] = [];
						vm.ficheros[key] = [];
						vm.respuesta[key] = {};
						if (value.tipologia == 88 && value.opciones.tipo_pregunta == 'selector')
							vm.respuesta[key] = { answerselector: null };

						if (value.tipologia == 89) {
							vm.respuesta[key] = [];
							angular.forEach(value.youtube_url.filas, function (vvvalue, vvkey) {
								vm.respuesta[key].push(false)
							});
						}

						vm.respuestas.push({ "tareas": value, "respuesta": {} });

						if (resp.status == 200) {
							if (resp.respuestas.stages[key]) {
								if (!vm.empty(resp.respuestas.stages[key].respuesta)) {
									const respuestas = resp.respuestas.stages[key].respuesta;
									let todasSonFalse = false;

									todasSonFalse = Object.values(respuestas).every(value =>
										Array.isArray(value) ? value.every(v => v === false) : value === false
									);


									if (!todasSonFalse) {
										vm.respuesta[key] = resp.respuestas.stages[key].respuesta;
										vm.pagina++;
										vm.ultima_respuesta++;
										swiperheader.slideTo(vm.pagina)
									}

								}
							}
						}
					});

				})
			})
		}

		vm.colaboracionSeleccionada = function (colaboracion_id) {
			ColaboracionService.colaboracionId(colaboracion_id).then(function (data) {
				vm.colaboracion = data.colaboracion;
			})
		}


		vm.completada = false;
		vm.next = function () {

			swiperheader.slideNext();
			vm.pagina = vm.pagina + 1;
			if (vm.pagina > vm.ultima_respuesta)
				vm.ultima_respuesta++;

			if (vm.pagina == 0) {

			} else if (vm.pagina == 1) {
				vm.result = vm.divisionTareas + vm.divisionTareas;
			} else if (vm.pagina > 1) {
				vm.result = vm.result + vm.divisionTareas;
			}

			angular.forEach(vm.respuestas, function (value, key) {
				vm.respuestas[key].respuesta = vm.respuesta[key];
				if (!vm.empty(vm.ficheros[key]))
					vm.respuestas[key].respuesta = vm.ficheros[key];
			});


			if (vm.pagina == vm.tareas.length) {
				var myModal = new bootstrap.Modal(document.getElementById('tareaCompletada'), {
					keyboard: false
				})
				myModal.show()
				vm.completada = true;
			}

			ColaboracionService.guardartareas(vm.id, vm.respuestas, vm.completada, vm.hash).then(function (data) {
				vm.completada = false;
			});
		}


		vm.subirFichero = function (data) {

			if (angular.isArray(data.data.file_id)) {
				angular.forEach(data.data.file_id, function (value, key) {
					vm.ficheros[vm.pagina].push({ "code": 200, "file_id": value, "name": data.data.name[key] })

				})
			} else {
				vm.ficheros[vm.pagina].push(data.data);

			}

			vm.fichero = data.data;
			vm.archivosubido = true;
			vm.fichero.errorfile = data.data.errorfile;
			vm.fileError = data.data.fileError;

			console.log("ficheros", vm.ficheros[vm.pagina]);


		}

		vm.archivosubido = false;

		vm.errorFichero = function () {
			var b = false;
			angular.forEach(vm.ficheros[vm.pagina], function (value, key) {

				if (value.errorfile) {
					// vm.errorArchivo = true;
					b = true;
					// vm.borrarFichero(value.file_id);

				}

			});
			return b;
		}

		vm.borrarFichero = function (index) {

			if (index > -1) {
				vm.ficheros[vm.pagina].splice(index, 1);
				//console.log(vm.ficheros[vm.pagina]);
				vm.archivosubido = false;
				vm.showerrors = false;
			}
		}

		vm.checkingfiles = function (max_limit, min_limit, fileslength) {
			var c = false;

			if ((max_limit < fileslength || min_limit > fileslength) && max_limit != 0) {
				// console.log("archivos no estan entre los limites ");

				c = true;

			} else {
				c = false;
				// console.log("correcto, esta entre los limites ");
			}

			return c;
		}

		vm.CheckedMultiple = function (pagina) {
			var contador = 0;
			vm.botonchecked = true;

			angular.forEach(vm.respuesta[pagina], function (value, index) {

				if (vm.botonchecked) {
					// Buscamos si la pregunta es de tipo múltiple
					var preguntas = (vm.tareas && vm.tareas[pagina]) ? vm.tareas[pagina].fichaspreguntas : [];
					var tarea = null;
					angular.forEach(preguntas, function (t) {
						if (parseInt(t.id) === parseInt(index)) tarea = t;
					});

					// IMPORTANTE: Solo validamos si es de tipo múltiple
					if (tarea && tarea.opciones && tarea.opciones.tipo_pregunta === 'multiple') {
						// Si no es obligatoria o está oculta, saltamos esta validación
						if (tarea.no_obligatoria === 1 || !vm.checkRequerida(tarea)) {
							return;
						}

						contador = 0;
						angular.forEach(value, function (val, subindex) {
							if (val && Number.isInteger(parseInt(subindex))) {
								contador++;
							}
						});

						if (contador >= 1) {
							vm.botonchecked = true;
						} else {
							vm.botonchecked = false;
						}
					}
				}



			});
			var inputNames = {}, topEl, err, i, arr, hasErrors = false, l;


			/*if ( !vm.botonchecked ) {
			   topEl = getTopElement(inputNames);
			   if (topEl.visibleEl.is(':input')) {
				 topEl.visibleEl.focus();
			   } else {
				 $location.hash(topEl.visibleEl.attr('id'));
				 $anchorScroll();
			   }
			}*/

			return vm.botonchecked;
		}

		function getTopElement(inputs) {
			var topEl = null;
			for (var inp in inputs) {

				if (!topEl) {
					topEl = inputs[inp];
				}
				if (inputs[inp].offset) {
					if (inputs[inp].offset.top < topEl.offset.top) {
						topEl = inputs[inp];
					} else if (inputs[inp].offset.top === topEl.offset.top) {
						if (inputs[inp].offset.left < topEl.offset.left) {
							topEl = inputs[inp];
						}
					}
				} else {
					//TODO - Is this possible ?
				}
			}
		}


		vm.Checked = function (key, tareaid, tarea) {
			var contador = 0;
			vm.botonchecked = true;
			var arr;

			// Si aún no hemos cargado los datos de respuestas de la página, evitamos errores
			if (!vm.respuesta || !vm.respuesta[key]) {
				return true;
			}

			// Si no nos pasan la tarea pero sí el ID, la buscamos
			if (tareaid !== undefined && tarea === undefined) {
				var preguntas = (vm.tareas && vm.tareas[key]) ? vm.tareas[key].fichaspreguntas : [];
				angular.forEach(preguntas, function (t) {
					if (parseInt(t.id) === parseInt(tareaid)) tarea = t;
				});
			}

			// Si la pregunta está oculta por su requisito, se considera "válida" (Checked = true)
			if (tarea && !vm.checkRequerida(tarea)) {
				return true;
			}

			if (tareaid === undefined) {
				arr = vm.respuesta[key];
			} else {
				arr = vm.respuesta[key][tareaid];
			}

			angular.forEach(arr, function (value, index) {
				if (value && Number.isInteger(parseInt(index))) {
					contador++;
				}
			});

			if (contador >= 1) {
				vm.botonchecked = true;
			} else {
				vm.botonchecked = false;
			}

			return vm.botonchecked;
		}

		vm.validCheck = function () {
			var b = false;
			angular.forEach(vm.answermultiple, function (value, key) {

				if (value) {
					b = true;
					vm.checkvalido = true;

				}
			});
			return b;
		}



		vm.filesaved = function (key) {
			var b = false;
			angular.forEach(vm.respuesta[key], function (value, key) {
				if (value)
					b = true;
			});

			return b;

		}

		vm.download = function (files) {

			//    vm.filesaved = true;
		}


		var contratoModal
		vm.modalContrato = function (contrato) {
			console.log("contrato", contrato);
			if (jQuery("#modalCheck").length) {
				contratoModal = new bootstrap.Modal(document.getElementById('modalCheck'), {
					keyboard: false
				})
				contratoModal.show()
			}


		}

		vm.modalAbonos = function () {
			var modalAbon = new bootstrap.Modal(document.getElementById('modalAbonos'), {
				keyboard: false
			})
			modalAbon.show()
		}

		vm.aceptoFirmaContrato = function (colaboracion_id,tarea_usuario_id,hash) {
			ColaboracionService.getFirmaContrato(colaboracion_id,tarea_usuario_id,hash).then(function (data) {
				vm.contrato = data.contrato;
				contratoModal.hide();
			})
		}

		vm.aceptoAnexoContrato = function (contratoId, userId) {
			ColaboracionService.firmarContrato(contratoId, userId).then(function (data) {
				contratoModal.hide();
			})
		}

		// vm.descargar = function(archivos){                
		//     angular.forEach(archivos,function(value,key){          

		//         document.getElementById('descarga').click();
		//         vm.down = value;
		//         console.log(vm.down); 
		//     // setTimeout(function() {

		//     //       $scope.$evalAsync();
		//     // }, 1000);

		//     }); 

		// }


		vm.modalContrato();

		vm.checkRequerida = function (tarea) {
			if (!tarea || !tarea.pregunta_requerida || !tarea.pregunta_requerida.tipo_pregunta) {
				return true;
			}

			var req = tarea.pregunta_requerida;
			var parentId = parseInt(req.tipo_pregunta);
			var reqValue = req.pregunta_requerida ? req.pregunta_requerida.respuesta_requerida : null;

			//console.log("--- Visualización Pregunta: " + tarea.id + " (Dep. del padre: " + parentId + ", Valor: " + reqValue + ") ---");

			if (!parentId || !reqValue) return true;

			// Como las preguntas 'single' usan el índice ($parent.$index), buscamos en qué posición está el ID del padre
			var parentIndex = -1;
			var parentQuestion = null;
			var preguntas = (vm.tareas && vm.tareas[vm.pagina]) ? vm.tareas[vm.pagina].fichaspreguntas : [];

			for (var i = 0; i < preguntas.length; i++) {
				if (parseInt(preguntas[i].id) === parentId) {
					parentIndex = i;
					parentQuestion = preguntas[i];
					break;
				}
			}

			if (parentIndex === -1) {
				console.log("  AVISO: Padre " + parentId + " no encontrado en la página actual.");
				return true;
			}

			// RECURSIVIDAD: Si el padre de esta pregunta está oculto por sus propios motivos, ocultamos también esta pregunta.
			var parentVisible = vm.checkRequerida(parentQuestion);
			//console.log("  Visibilidad del padre (" + parentId + "): " + parentVisible);
			if (!parentVisible) {
				return false;
			}

			var respuestasPagina = vm.respuesta[vm.pagina] || {};

			// Primero: Comprobamos si el padre es de tipo Single (usan índice como clave)
			if (respuestasPagina.answersingle && respuestasPagina.answersingle[parentIndex] !== undefined) {
				var finalResultSingle = respuestasPagina.answersingle[parentIndex] === reqValue;
				//console.log("  Resultado Single: " + finalResultSingle);
				return finalResultSingle;
			}

			// Segundo: Comprobamos si el padre es de tipo Multiple (usan ID del padre y luego índice de la opción)
			if (respuestasPagina[parentId] && typeof respuestasPagina[parentId] === 'object') {
				// Buscamos el índice de la opción cuyo texto coincide con reqValue en la pregunta padre
				var optionIndex = -1;
				if (parentQuestion && parentQuestion.questions) {
					for (var j = 0; j < parentQuestion.questions.length; j++) {
						if (parentQuestion.questions[j] === reqValue) {
							optionIndex = j;
							break;
						}
					}
				}

				if (optionIndex !== -1) {
					// Comprobamos si ese checkbox está marcado (true)
					var finalResultMultiple = respuestasPagina[parentId][optionIndex] === true;
					//console.log("  Resultado Múltiple: " + finalResultMultiple);
					return finalResultMultiple;
				}
			}

			return false;
		};
	}




})();